import { Survey } from '@ps/survey-utils';

export function hasPendingChannel(trafficChannels: Survey[]): boolean {
  return trafficChannels.some((channel) => channel.isPending);
}
